<template>
  <v-snackbar v-model="updateExists" bottom :timeout="-1">
    {{ $t('title') }}
    <template v-slot:action="{ attrs }">
      <v-btn text color="default" v-bind="attrs" @click="refreshApp">{{ $t('reload') }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'RefreshApp',
  data: () => ({
    refreshing: false,
    registration: null,
    updateExists: false
  }),
  methods: {
    showRefreshUI(e) {
      this.registration = e.detail
      this.updateExists = true
    },
    refreshApp() {
      this.updateExists = false
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage('skipWaiting')
    }
  },
  created() {
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  }
}
</script>

<i18n>
{
  "en": {
    "reload": "@:labels.reload",
    "title": "New version available!"
  },
  "fr": {
    "reload": "@:labels.reload",
    "title": "Nouvelle version disponible!"
  }
}
</i18n>
